module.exports = __webpack_public_path__ + "static/icon-heart-mask-afro-3e2b5049aba66f938156c8fdc0771a5e.svg";